import { render, staticRenderFns } from "./CdbCustomerTourRecordList.vue?vue&type=template&id=5c402668&scoped=true&"
import script from "./CdbCustomerTourRecordList.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerTourRecordList.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerTourRecordList.vue?vue&type=style&index=0&id=5c402668&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c402668",
  null
  
)

export default component.exports